// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__exf8Z","vatRate":"styles_vatRate__d_cUC","vatRateLabel":"styles_vatRateLabel___muKf","slideInSearchBar":"styles_slideInSearchBar__KCjZB"};